import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { GoKebabHorizontal } from "react-icons/go";
import { FaCheck } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBinLine } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";

import axios from "axios";
import { useMessage } from "../../../../components/Header";
import { useTheme } from "../../../../style/theme";
import Noleaveapplication from "../../../DashComponents/Noleaveapplication";

const LeaveViewPage = ({
  leaveAppData = [],
  isDashboardCall,
  LeaveDetails,
  rows,
  setPage,
  setRowsPerPage,
  page,
  rowsPerPage,
  paginationModel,
  Mydata = false
}) => {
  console.log("🚀 ~ rowsPerPage:", rowsPerPage)
  console.log("🚀 ~ page:", page)
  console.log("🚀 ~ rows:", rows)
  const { mode } = useTheme();
  const [leavedata, setLeaveData] = useState(leaveAppData);
  const [leavetype, setLeavetype] = useState([]);
  const { showError, showSuccess } = useMessage();
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);
  let currentOrg = JSON.parse(localStorage.getItem("org"));
  let currentEmp =
    currentOrg?.type === "Member"
      ? JSON.parse(localStorage.getItem("emp"))
      : null;

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const handleChangePage = (newPage) => {
    if (newPage < 0 || newPage >= paginationModel.totalPages) return;

    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const getLeaveTypeName = (leaveTypeId) => {
    const leaveType = leavetype.find((type) => type._id === leaveTypeId);
    return leaveType ? leaveType.name : "Compensatory off";
  };

  const calculateLeaveDays = (dates) => {
    if (dates.length < 2) return 1;
    const startDate = new Date(dates[0].year, dates[0].month - 1, dates[0].day);
    const endDate = new Date(
      dates[dates.length - 1].year,
      dates[dates.length - 1].month - 1,
      dates[dates.length - 1].day
    );
    const diffTime = Math.abs(endDate - startDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  };

  const LeaveType = useCallback(async () => {
    try {
      const response = await axios.get(
        `/hr/attendance/leaves-types?orgId=${currentOrg?._id}`
      );
      setLeavetype(response.data.leaveTypes);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const acceptLeave = useCallback(
    async (id) => {
      setAcceptLoading(true);
      try {
        const res = await axios.post(`/hr/attendance/leaves/approve/${id}`);
        LeaveDetails();
        const { success, message } = res.data;
        success ? showSuccess(message) : showError(message);
      } catch (e) {
        console.log(e);
      } finally {
        setAcceptLoading(false);
      }
    },
    [LeaveDetails, showSuccess, showError]
  );

  const rejectLeave = useCallback(
    async (id) => {
      try {
        const res = await axios.post(`/hr/attendance/leaves/deny/${id}`);
        LeaveDetails();
        const { success, message } = res.data;
        success ? showSuccess(message) : showError(message);
      } catch (e) {
        showError(e);
      }
    },
    [LeaveDetails, showSuccess, showError]
  );

  useEffect(() => {
    if (!isDashboardCall) {
      // LeaveDetails(); // optional initial call
    } else {
      setLeaveData(leaveAppData);
    }
    LeaveType();
  }, [LeaveType]);

  return (
    <Box>
      <div className="flex flex-col">
        {leaveAppData?.length > 0 ? (
          <Box
            className="rounded-lg p-3"
            sx={{ border: mode === "dark" ? "1px solid #1F1F1F" : "" }}
          >
            {/* Rows per page */}
            <div className="flex items-center mb-2">
              <span className="md:text-sm text-[9px]">Rows per page:</span>
              <FormControl size="small" className="rounded-md ml-2">
                <Select
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  sx={{
                    color: "text.primary",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    p: 0,
                    fontSize: { xs: "9px", md: "14px" },
                  }}
                >
                  {[10, 20, 30].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Table */}
            <TableContainer className="rounded-lg" sx={{ overflowY: "auto" }}>
              <Table>
                <TableHead
                  sx={{
                    backgroundColor: mode === "light" ? "#f7f9fc" : "#171717",
                  }}
                >
                  <TableRow>
                    <TableCell>Emp ID</TableCell>
                    {currentOrg?.type === "Owner" && !Mydata && (
                      <TableCell>Emp Name</TableCell>
                    )}
                    <TableCell>Leave Type</TableCell>
                    <TableCell>From</TableCell>
                    <TableCell>To</TableCell>
                    <TableCell>Days</TableCell>
                    <TableCell>Reason</TableCell>
                    <TableCell>Applied On</TableCell>
                    <TableCell>Status</TableCell>
                    {currentOrg?.type === "Owner" && (
                      <TableCell>Action</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leaveAppData?.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell>{index + 1}</TableCell>
                      {currentOrg?.type === "Owner" && !Mydata && (
                        <TableCell>{row?.fullName}</TableCell>
                      )}
                      <TableCell>
                        {row?.leaveType
                          ? getLeaveTypeName(row?.leaveType)
                          : "Compensatory off"}
                      </TableCell>
                      <TableCell>{`${row?.dates?.[0]?.year}-${row?.dates?.[0]?.month}-${row?.dates?.[0]?.day}`}</TableCell>
                      <TableCell>
                        {row?.dates?.length > 1
                          ? `${row?.dates.at(-1).year}-${
                              row?.dates.at(-1).month
                            }-${row?.dates.at(-1).day}`
                          : "-"}
                      </TableCell>
                      <TableCell>{calculateLeaveDays(row?.dates)}</TableCell>
                      <TableCell>{row.reason}</TableCell>
                      <TableCell>
                        {new Date(row?.createdAt).toLocaleDateString()}
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            px: 1,
                            py: 1,
                            textAlign: "center",
                            borderRadius: "6px",
                            fontWeight: "bold",
                            backgroundColor:
                              mode === "dark"
                                ? row.status === "Approved"
                                  ? "#182115"
                                  : row.status === "Rejected"
                                  ? "#261717"
                                  : row.status === "Pending"
                                  ? "#271f13"
                                  : "transparent"
                                : "background.view",
                            color:
                              row.status === "Approved"
                                ? "#42b824"
                                : row.status === "Rejected"
                                ? "#f13b3b"
                                : row.status === "Pending"
                                ? "#ff9b05"
                                : "",
                          }}
                        >
                          {row.status}
                        </Box>
                      </TableCell>
                      {currentOrg?.type === "Owner" && (
                        <TableCell>
                          <div className="relative">
                            <div
                              className="cursor-pointer"
                              onClick={() => toggleMenu(row._id)}
                            >
                              <GoKebabHorizontal size={20} className="m-auto" />
                            </div>
                            {openMenuId === row._id && (
                              <Box
                                sx={{ bgcolor: "background.paper" }}
                                className="absolute right-0 mt-2 w-32 shadow-lg rounded-lg z-40"
                              >
                                <ul className="text-sm">
                                  {row?.status !== "Approved" && (
                                    <li
                                      className="cursor-pointer"
                                      onClick={() => acceptLeave(row?._id)}
                                    >
                                      <div className="flex items-center gap-2">
                                        <IconButton>
                                          <FaCheck
                                            style={{ fontSize: "14px" }}
                                          />
                                        </IconButton>
                                        <button className="block w-full text-left py-2">
                                          Accept
                                        </button>
                                      </div>
                                    </li>
                                  )}
                                  {row?.status === "Pending" && (
                                    <li
                                      className="cursor-pointer"
                                      onClick={() => rejectLeave(row?._id)}
                                    >
                                      <div className="flex items-center gap-2">
                                        <IconButton>
                                          <IoMdClose
                                            style={{ fontSize: "16px" }}
                                          />
                                        </IconButton>
                                        <button className="block w-full text-left py-2">
                                          Reject
                                        </button>
                                      </div>
                                    </li>
                                  )}
                                  <li className="cursor-pointer">
                                    <div className="flex items-center gap-2">
                                      <IconButton>
                                        <FiEdit style={{ fontSize: "16px" }} />
                                      </IconButton>
                                      <button className="block w-full text-left py-2">
                                        Edit
                                      </button>
                                    </div>
                                  </li>
                                  <li className="cursor-pointer">
                                    <div className="flex items-center gap-2">
                                      <IconButton>
                                        <RiDeleteBinLine
                                          style={{ fontSize: "16px" }}
                                        />
                                      </IconButton>
                                      <button className="block w-full text-left py-2">
                                        Delete
                                      </button>
                                    </div>
                                  </li>
                                </ul>
                              </Box>
                            )}
                          </div>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            <div className="flex justify-between items-center mt-2">
              <span className="text-sm">
                {Number.isFinite(page) &&
                Number.isFinite(rowsPerPage) &&
                Number.isFinite(rows) &&
                rows !== 0
                  ? `Showing Rows: ${page * rowsPerPage + 1} - ${Math.min(
                      (page + 1) * rowsPerPage,
                      rows
                    )} of ${rows}`
                  : "Showing Rows: 0 - 0 of 0"}
              </span>

              <div className="flex items-center gap-2">
                <IconButton
                  sx={{ bgcolor: "background.view" }}
                  onClick={() => handleChangePage(page - 1)}
                  disabled={paginationModel.PagesLenght <= 1}
                  className="text-white hover:bg-[#3A3B3C] rounded-lg"
                >
                  <MdKeyboardArrowLeft />
                </IconButton>

                <span className="p-1 text-white px-2 bg-[#0080FF] rounded-full text-xs font-bold">
                  {paginationModel.PagesLenght}
                </span>

                <IconButton
                  onClick={() => handleChangePage(page + 1)}
                  disabled={
                    paginationModel.PagesLenght >= paginationModel.totalPages
                  }
                  className="text-white hover:bg-[#3A3B3C] rounded-lg"
                >
                  <MdKeyboardArrowRight />
                </IconButton>
              </div>
            </div>
          </Box>
        ) : (
          <Noleaveapplication />
        )}
      </div>
    </Box>
  );
};

export default LeaveViewPage;
